import { ElementWithProps, createComponent } from '@carvana/merch-components';
import cx from 'classnames';

export const DesktopEllipseImg = createComponent<
  ElementWithProps<{ isGeneric?: boolean }, HTMLImageElement>
>('img', ({ isGeneric }) => ({
  alt: '',
  'aria-hidden': true,
  className: cx(
    'absolute h-full w-full select-none object-cover top-[165px] left-[40px]',
    {
      'max-h-[486px]': isGeneric,
      'max-h-[400px]': !isGeneric
    }
  )
}));

export const TabletImg = createComponent<
  ElementWithProps<object, HTMLImageElement>
>('img', () => ({
  // Pinned to the baseline 364px crop, offset 298px (= (TABLET_MASK_CANVAS_HEIGHT - 364) / 2)
  // down within the taller mask canvas — stays put as the hero grows, matching the mask.
  className:
    'absolute h-full max-h-[400px] max-w-none select-none top-[282px] left-[40vw]'
}));

export const DesktopEllipse = createComponent<ElementWithProps>('a', {
  className:
    'absolute h-[960px] w-[960px] [mask-image:var(--desktop-ellipse-mask)] [mask-repeat:no-repeat] [mask-size:100%_100%]'
});
